import React from 'react';
import './ProjectStyle.css'; // Shared CSS for all projects
import projectVideo from '../../Videos/Perception.mp4';

const ProjectTemplate = () => {
  return (
    <div className="project-container">
      <div className="navbar-non-transparent"></div>
      <div className="title">
        <h1>Perception — Voice-Driven CAD in Mixed Reality</h1>
      </div>

      <div className="project-image-section">
        <video className="project-image" controls>
          <source src={projectVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="tools">
        <p>
          <em>
            <strong>
              Made with: WebXR, Three.js, JavaScript, Python, FastAPI,
              CadQuery, NVIDIA TRELLIS, OpenAI / Gemini, ElevenLabs,
              Composio and Ultimaker Cura
            </strong>
          </em>
        </p>
      </div>

      <div className="project-content">
        <section className="project-section">
          <h2>Overview</h2>
          <p>
            Built at Hack the North 2026, Perception turns a room into a
            mixed-reality design studio. Our voice assistant, Percy, translates
            spoken ideas into 3D models that appear in front of you on the Meta
            Quest 3. You can inspect them at scale, manipulate them with your
            hands, refine their dimensions, and export them for fabrication.
            We demonstrated the complete workflow from a spoken idea to a
            physical, 3D-printed part.
          </p>
        </section>

        <section className="project-section">
          <h2>From Voice to Geometry</h2>
          <p>
            ElevenLabs handles speech input and Percy's spoken responses, while
            an AI reasoning layer interprets requests and routes them to the
            appropriate modeling tools. Dimensional parts use generated
            CadQuery scripts to build parametric geometry; organic objects use
            a separate text- or image-to-3D pipeline with providers such as
            NVIDIA TRELLIS. A Python/FastAPI backend coordinates generation
            and delivers GLB models to the WebXR and Three.js client for
            rendering in passthrough AR.
          </p>
        </section>

        <section className="project-section">
          <h2>Hands-On Spatial Editing</h2>
          <p>
            Users can grab and rotate models with a pinch, or use both hands
            to adjust their viewing scale and position without changing the
            part's manufactured dimensions. Dragging dimension controls
            updates named CAD parameters and rebuilds the geometry without
            another LLM call. Surface-to-surface measurements and lasso
            selection support inspection and targeted edits, while per-object
            version history lets users undo and redo changes.
          </p>
        </section>

        <section className="project-section">
          <h2>Engineering for Responsiveness</h2>
          <p>
            Heavy generation runs off the headset, leaving the Quest to render
            and handle interaction. Long-running image-to-3D requests use
            detached backend jobs with client polling, allowing generation to
            continue through a temporary headset disconnection. For dimension
            edits, we parse and rewrite the CAD script's parameter dictionary
            using Python's abstract syntax tree, preserving the rest of the
            script and avoiding a full AI code-generation cycle.
          </p>
        </section>

        <section className="project-section">
          <h2>Connected Workflow and Fabrication</h2>
          <p>
            Composio connects Percy to tools including Gmail, Google Drive,
            Notion and GitHub, bringing project context and reference images
            into the design workflow. CAD models support STL and STEP export,
            while GLB serves the mixed-reality viewer. We used Ultimaker Cura
            to slice exported geometry and complete the transition from an
            in-headset design to a printed part.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ProjectTemplate;